module.exports = __webpack_public_path__ + "static/media/under-construction.f3dee092.jpg";